export default __webpack_public_path__ + "static/media/greenKustomize.65fa19a2.svg";